import { ApplicationActionType } from '../../../ApplicationConstants';
import { performCellDoubleClick } from './onCellDblClick';

export const onCellDblClickSummary = (e) => {
    performCellDoubleClick(e, ApplicationActionType.Summary);
};
